const { CarouselElement } = window.BAO.Carousel
const { setInitialised } = window.BAO.Carousel.plugins

export class ProductCarousel extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide']
  }

  /** @returns {KeenSliderOptions} */
  get options () {
    return {
      disabled: false,
      slides: {
        perView: this.dataset.mobileSlides,
        spacing: 10,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: this.dataset.desktopSlides,
            spacing: 30,
          },
        },
      },
    }
  }

  /** @returns {KeenSliderPlugin[]} */
  get plugins () {
    return [setInitialised()]
  }
}

if (!customElements.get('stl-carousel')) {
  customElements.define('stl-carousel', ProductCarousel)
}
